<template>
  <div class="content">
    <div class="container pt-2">
      <div
        v-if="loginIsVisible"
        class="form-login 
            col-lg-5 
            col-md-6
            ml-auto 
            mr-auto 
            text-center"
      >
        <h2 class="card-title my-5">Acceso a pedidos</h2>
        <p class="text-danger mb-0">
          <b>
            {{ erroresInputs.inputDocumento }}
          </b>
        </p>
        <fg-input
          class="input-lg"
          addon-left-icon="fas fa-user"
          placeholder="Documento de identidad"
          v-model="username"
          @keypress="restrictChars($event)"
        >
        </fg-input>
        <p class="text-danger mb-0">
          <b>
            {{ erroresInputs.inputPassword }}
          </b>
        </p>
        <fg-input
          class="input-lg"
          addon-left-icon="fas fa-keyboard"
          placeholder="Contraseña"
          type="password"
          v-model="password"
        >
        </fg-input>
        <button
          @click="loginUsuario()"
          class="btn btn-primary btn-round btn-lg btn-block text-white"
          :disabled="iniciandoSesion"
        >
          <span v-if="!iniciandoSesion">ACCEDER</span>
          <span
            v-if="spinners.iniciandoSesion"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>

        <!-- <a
            @click="loginUsuario()"
            class="btn btn-primary btn-round btn-lg btn-block text-white"
          >
            ACCEDER
            <span v-if="spinners.iniciandoSesion" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </a> -->
        <p>
          <b>
            Si usted desea realizar un pedido y aun no se encuentra registrado,
            comuníquese via telefonica.
          </b>
        </p>
      </div>
      <div
        v-if="completarRegistroIsVisible"
        class="form-completar-registro col-md-5 ml-auto mr-auto text-center"
      >
        <h4 class="card-title my-5 ">Llena los siguientes datos</h4>
        <fg-input
          class="input-lg"
          addon-left-icon="now-ui-icons users_circle-08"
          placeholder="Primer nombre"
          v-model="primerNombre"
        >
        </fg-input>
        <fg-input
          class="input-lg"
          addon-left-icon="now-ui-icons users_circle-08"
          placeholder="Segundo nombre"
          v-model="segundoNombre"
        >
        </fg-input>
        <fg-input
          class="input-lg"
          addon-left-icon="now-ui-icons users_circle-08"
          placeholder="Apellidos"
          v-model="apellidos"
        >
        </fg-input>
        <fg-input
          class="input-lg"
          addon-left-icon="now-ui-icons text_caps-small"
          placeholder="Nueva contraseña"
          type="password"
          v-model="nuevoPassword"
        >
        </fg-input>
        <a
          @click="completarRegistro()"
          class="btn btn-primary btn-round btn-lg btn-block text-white"
        >
          ENVIAR
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from "@/components";
import { Auth } from "aws-amplify";

export default {
  mounted: function() {
    this.usuarioEstaLogueado();
  },
  name: "login-page",
  bodyClass: "login-page",
  data() {
    return {
      username: "",
      password: "",
      primerNombre: "",
      segundoNombre: "",
      apellidos: "",
      nuevoPassword: "",
      hayErroresInputDocumento: false,
      hayErroresInputPassword: false,
      loginIsVisible: false,
      completarRegistroIsVisible: false,
      spinners: {
        iniciandoSesion: false,
      },
      erroresInputs: {
        inputDocumento: "",
        inputPassword: "",
      },
    };
  },
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  methods: {
    formLoginEsValido() {
      let valido = true;
      this.erroresInputs.inputDocumento = "";
      this.erroresInputs.inputPassword = "";

      if (this.username == "") {
        this.erroresInputs.inputDocumento = "Digite su número de documento";
        valido = false;
      }
      if (this.password == "") {
        this.erroresInputs.inputPassword = "Digite su contraseña";
        valido = false;
      }
      //consolconsole.log(this.erroresInputs)
      return valido;
    },
    restrictChars: function($event) {
      //Restringir para solo aceptar numeros con el teclado
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    mostrarLogin() {
      this.loginIsVisible = true;
      this.completarRegistroIsVisible = false;
    },
    mostrarCompletarRegistro() {
      this.loginIsVisible = false;
      this.completarRegistroIsVisible = true;
    },
    async loginUsuario() {
      this.erroresInputs.inputDocumento = "";
      this.erroresInputs.inputPassword = "";
      if (this.formLoginEsValido()) {
        this.spinners.iniciandoSesion = true;
        Auth.signIn({
          username: this.username, // Required, the username
          password: this.password, // Optional, the password
        })
          .then((user) => {
            if (user.challengeName == "NEW_PASSWORD_REQUIRED") {
              //Mostrar/Ir a la vista de completar registro
              this.mostrarCompletarRegistro();
              this.spinners.iniciandoSesion = false;
            } else {
              this.usuarioEstaLogueado();
              this.spinners.iniciandoSesion = false;
            }
          })
          .catch((err) => {
            //console.log("signIn -  err", err)
            this.erroresInputs.inputDocumento =
              "Documento o contraseña incorrecto";
            this.spinners.iniciandoSesion = false;
          });
      }
    },
    async usuarioEstaLogueado() {
      Auth.currentAuthenticatedUser({
        bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then((user) => {
          //Cargar datos del usuario e ir a la vista de pedidos
          //console.log("currentAuthenticatedUser - user: ", user)
          this.$router.push("pedidos");
        })
        .catch((err) => {
          //console.log("currentAuthenticatedUser - err: ", err)
          //Ir al login
          this.mostrarLogin();
        });
    },
    async completarRegistro() {
      // Incluir dentro de la misma vista de login
      Auth.signIn({
        username: this.username,
        password: this.password,
      })
        .then((user) => {
          //const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
          //console.log("requiredAttributes: " + requiredAttributes )
          Auth.completeNewPassword(
            user, // the Cognito User Object
            this.nuevoPassword, // the new password
            // OPTIONAL, the required attributes
            {
              middle_name: this.segundoNombre,
              given_name: this.primerNombre,
              family_name: this.apellidos,
            }
          )
            .then((user) => {
              // at this time the user is logged in if no MFA required
              //Aqui ya el usuario completó los datos del registro y esta con la sesion iniciada
              //console.log("user: ", user);
              this.usuarioEstaLogueado();
            })
            .catch((e) => {
              console.log("e: ", e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style>
.content {
  min-height: calc(100vh - 200px);
}

.text-danger {
  font-size: 0.7em;
}
</style>
